export const requestHeaders = (token: string, type?: string) => {
  return {
    'Content-Type': `${!type ? 'application/json'  : type}`,
    Authorization: {
      toString() {
        return `Bearer ${token}`;
      },
    },
  };
};